import React from 'react';
import { RadioButton } from './RadioButton';
import styles from '../../styles/components/answers/Rating.module.css';
import UUID from '@ax2/common/model/UUID';

export interface RatingOption {
  id: UUID;
  title?: string;
  subtitle?: string;
}
export interface RatingData {
  options: RatingOption[];
  preselected?: RatingOption;
  tabIndexStart: number;
  onCompletion: (opt: RatingOption) => void;
  key?: string;
}

function getCellClassName(pos: number, maxPos: number) {
  return pos === 0
    ? styles.firstRatingContainer
    : pos === maxPos
    ? styles.lastRatingContainer
    : styles.ratingContainer;
}

export const RatingDesktop: React.FC<RatingData> = data => {
  const [selection, setSelection] = React.useState<RatingOption | undefined>(
    data.preselected
  );
  const maxPos = data.options.length - 1;
  return (
    <div className={styles.ratingWrapper}>
      {data.options.map((option, index, allOptions) => {
        const isSelected = option === selection;
        const isBeforeSelected =
          selection &&
          allOptions.indexOf(selection) > allOptions.indexOf(option);
        return (
          <div key={index} className={getCellClassName(index, maxPos)}>
            {option.title && (
              <span className={styles.ratingTitle}>{option.title}</span>
            )}
            {!option.title && option.subtitle && (
              <span className={styles.ratingSubtitle}>{option.subtitle}</span>
            )}
            <div className={styles.radioButtonWrapper}>
              {index !== 0 && (
                <div
                  className={
                    isSelected || isBeforeSelected
                      ? styles.separator
                      : styles.separatorInactive
                  }
                  style={{ marginRight: '-0.5rem' }}
                ></div>
              )}
              <RadioButton
                tabIndex={data.tabIndexStart + index + 1}
                hasSelection={
                  selection !== undefined && selection.id === option.id
                }
                onCompletion={_v => {
                  setSelection(option);
                  data.onCompletion(option);
                }}
              />
              {index !== maxPos && (
                <div
                  className={
                    isBeforeSelected
                      ? styles.separator
                      : styles.separatorInactive
                  }
                  style={{ marginLeft: '-0.5rem' }}
                ></div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const RatingMobile: React.FC<RatingData> = data => {
  const [selection, setSelection] = React.useState<RatingOption | undefined>(
    data.preselected
  );
  return (
    <div className={styles.ratingMobileWrapper}>
      {data.options.map((option, index) => {
        return (
          <div key={index} className={styles.ratingMobileContainer}>
            <div className={styles.radioButtonWrapper}>
              <RadioButton
                tabIndex={data.tabIndexStart + index + 1}
                hasSelection={
                  selection !== undefined && selection.id === option.id
                }
                onCompletion={_v => {
                  setSelection(option);
                  data.onCompletion(option);
                }}
              />
            </div>
            {option.subtitle && (
              <span className={styles.ratingSubtitle}>
                {option.subtitle + '.'}
              </span>
            )}
            {option.title && (
              <span className={styles.ratingTitle}>{option.title}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};
